module.exports = __webpack_public_path__ + "static/media/reel.89ecb30c.png";